import { ConsumerAuthenticationDto } from '#modules/Bank/Bank.types'
import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../fluxStandardAction'
import { BankError } from '#modules/Bank/Bank.types'

export type AuthenticateWithSessionIdAction = FluxStandardAction<
	'transactionClientApp/authenticate/withSessionId',
	{
		sessionId: string
	}
>

export type AuthenticateWithInstructionIdAction = FluxStandardAction<
	'transactionClientApp/authenticate/withInstructionId',
	{
		instructionId: string
	}
>

export type AuthenticateSucceededAction = FluxStandardAction<
	'transactionClientApp/authenticate/succeeded',
	{
		sessionId: string
		authenticateDto: ConsumerAuthenticationDto
	}
>

export type AuthenticateFailedAction =
	FluxStandardFailureAction<'transactionClientApp/authenticate/failed'>

export type AuthenticateConsumerAction =
	| AuthenticateWithSessionIdAction
	| AuthenticateWithInstructionIdAction
	| AuthenticateSucceededAction
	| AuthenticateFailedAction

export function authenticateWithSessionId(
	sessionId: string,
): AuthenticateWithSessionIdAction {
	return {
		type: 'transactionClientApp/authenticate/withSessionId',
		payload: {
			sessionId,
		},
	}
}

export function authenticateWithInstructionId(
	instructionId: string,
): AuthenticateWithInstructionIdAction {
	return {
		type: 'transactionClientApp/authenticate/withInstructionId',
		payload: {
			instructionId,
		},
	}
}

export function authenticateSucceeded(
	sessionId: string,
	authenticateDto: ConsumerAuthenticationDto,
): AuthenticateSucceededAction {
	return {
		type: 'transactionClientApp/authenticate/succeeded',
		payload: {
			sessionId,
			authenticateDto: authenticateDto,
		},
	}
}

export function authenticateFailed(
	authenticateError: BankError,
): AuthenticateFailedAction {
	return {
		type: 'transactionClientApp/authenticate/failed',
		payload: authenticateError,
		error: true,
	}
}
